import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/textelements/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/tooltip/tooltipview
 */
import View from "../view";
import "../../theme/components/tooltip/tooltip.css";
/**
 * The tooltip view class.
 *
 * @extends module:ui/view~View
 */

var TooltipView =
/*#__PURE__*/
function (_View) {
  _inherits(TooltipView, _View);

  /**
   * @inheritDoc
   */
  function TooltipView(locale) {
    var _this;

    _classCallCheck(this, TooltipView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TooltipView).call(this, locale));
    /**
     * The text of the tooltip visible to the user.
     *
     * @observable
     * @member {String} #text
     */

    _this.set('text', '');
    /**
     * The position of the tooltip (south or north).
     *
     *		+-----------+
     *		|   north   |
     *		+-----------+
     *		      V
     *		  [element]
     *
     *		  [element]
     *		      ^
     *		+-----------+
     *		|   south   |
     *		+-----------+
     *
     * @observable
     * @default 's'
     * @member {'s'|'n'} #position
     */


    _this.set('position', 's');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'span',
      attributes: {
        class: ['ck', 'ck-tooltip', bind.to('position', function (position) {
          return 'ck-tooltip_' + position;
        }), bind.if('text', 'ck-hidden', function (value) {
          return !value.trim();
        })]
      },
      children: [{
        tag: 'span',
        attributes: {
          class: ['ck', 'ck-tooltip__text']
        },
        children: [{
          text: bind.to('text')
        }]
      }]
    });

    return _this;
  }

  return TooltipView;
}(View);

export { TooltipView as default };